import { Component, OnInit, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { BreadcrumbService } from '@shared/services/breadcrumb/breadcrumb.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ModalComponent } from 'thkee-common';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-payout-request-monthly',
    templateUrl: './payout-request-monthly.component.html',
    styleUrls: ['./payout-request-monthly.component.scss'],
    imports: [AngularSvgIconModule, FormsModule, ReactiveFormsModule, FormlyModule, RouterLink, ModalComponent, CurrencyPipe, DatePipe]
})
export class PayoutRequestMonthlyComponent implements OnInit {
  private breadcrumbService = inject(BreadcrumbService);

  // Pageination items
  paginationForm = new FormGroup({});
  paginationFormModel: any = {};
  paginationFormFields: FormlyFieldConfig[] = [
    {
      key: 'page',
      type: 'select',
      defaultValue: '5',
      props: {
        wrapAppendClass: ['!mb-3'],
        label: '',
        placeholder: '',
        multiple: false,
        stayPlaceholder: true,
        disabled: false,
        tips: 'Select the number of items displayed into the table',
        stylish: true,
        options: [
          { label: '5', value: '5' },
          { label: '10', value: '10' },
          { label: '15', value: '15' },
        ],
      },
      expressions: {},
    },
  ];

  // Filter form
  filterForm = new FormGroup({});
  filterFormModel: any = {};
  filterFormFields: FormlyFieldConfig[] = [
    {
      template: `<div class="text-base text-neutral-800 font-semibold border-b border-neutral-100 pb-2.5 mb-2.5">Payout Type</div>`,
    },
    {
      key: 'on_demand',
      type: 'checkbox',
      className: '',
      props: {
        label: 'On-demand (16)',
        required: true,
      },
    },
    {
      key: 'monthly',
      type: 'checkbox',
      className: '',
      props: {
        label: 'Monthly (16)',
        required: true,
      },
    },
    {
      template: `<div class="text-base text-neutral-800 font-semibold border-b border-neutral-100 pb-2.5 mb-2.5 mt-2">Payout Status</div>`,
    },
    {
      key: 'paid',
      type: 'checkbox',
      className: '',
      props: {
        label: 'Paid (16)',
        required: true,
      },
    },
    {
      key: 'inactive',
      type: 'checkbox',
      className: '',
      props: {
        label: 'Inactive (16)',
        required: true,
      },
    },
    {
      key: 'failed',
      type: 'checkbox',
      className: '',
      props: {
        label: 'Failed (16)',
        required: true,
      },
    },
    {
      template: `<div class="text-base text-neutral-800 font-semibold border-b border-neutral-100 pb-2.5 mt-2">Payout Amount</div>`,
    },
    {
      fieldGroupClassName: 'flex gap-2 items-center mb-4',
      fieldGroup: [
        {
          key: 'min',
          type: 'input',
          className: 'w-[78px]',
          props: {
            label: '',
            placeholder: '$ 1',
          },
        },
        {
          template: '-',
        },
        {
          key: 'max',
          type: 'input',
          className: 'w-[78px]',
          props: {
            label: '',
            placeholder: '$ 20',
          },
        },
      ],
    },
    {
      template: `<div class="text-base text-neutral-800 font-semibold border-b border-neutral-100 pb-2.5 mt-2">Transactions</div>`,
    },
    {
      fieldGroupClassName: 'flex gap-2 items-center mb-4',
      fieldGroup: [
        {
          key: 'min',
          type: 'input',
          className: 'w-[78px]',
          props: {
            label: '',
            placeholder: '1',
          },
        },
        {
          template: '-',
        },
        {
          key: 'max',
          type: 'input',
          className: 'w-[78px]',
          props: {
            label: '',
            placeholder: '20',
          },
        },
      ],
    },
  ];
  resetFilter() {
    this.filterForm.reset();
  }

  ngOnInit(): void {
    let breadcrumb: any = [
      {
        label: 'E-Commerce',
        url: '/ecommerce/dashboard',
      },
      {
        label: 'Payouts',
        url: '/ecommerce/payout/paid-payout/all',
      },
      {
        label: 'Payout Request',
        url: '/ecommerce/payout/payouts-requests/all',
      },
    ];
    this.breadcrumbService.setBreadcrumbs(breadcrumb);
  }

  // Dropdown methode
  isDropdown: { [key: string]: boolean } = {};
  dropdown(type: any) {
    this.isDropdown[type] = !this.isDropdown[type];
  }
  // Status methode
  getStatus(status: string = 'Paid') {
    let style = { bg: '', text: '' };
    if (status === 'Paid') {
      style.bg = 'bg-teal-50';
      style.text = 'text-teal-600';
    } else if (status === 'Failed') {
      style.bg = 'bg-rose-50';
      style.text = 'text-rose-600';
    } else {
      style.bg = 'bg-neutral-50';
      style.text = 'text-neutral-600';
    }
    return style;
  }
  // Checked function
  checkAllCheckBox(ev: any) {
    this.dummyData.forEach((x: any) => (x.checked = ev.target.checked));
  }
  isAllCheckBoxChecked() {
    this.checkedItemsCount();
    return this.dummyData.every((p: any) => p.checked);
  }
  checkedItemsCount() {
    let count = 0;
    this.dummyData.forEach((x: any) => {
      if (x.checked) count++;
    });
    return count;
  }
  checked(ev: any) {
    ev.stopPropagation();
  }

  // Payment history
  public paymentHistory: any = [
    {
      id: 1,
      title: 'Paypal Balances',
      value: 10000,
      type: 'currency',
    },
    {
      id: 2,
      title: 'Bank Balances',
      value: 78,
      type: 'currency',
    },
    {
      id: 3,
      title: 'Payoneer Balances',
      value: 228,
      type: 'currency',
    },
    {
      id: 4,
      title: 'Total To Pay',
      value: 1024,
      type: 'currency',
    },
  ];
  public paymentCardHistory: any = [
    {
      id: 5,
      title: 'Total Transactions',
      value: 24,
      type: 'number',
    },
    {
      id: 6,
      title: 'Total of Payees',
      value: 60,
      type: 'number',
    },
    {
      id: 7,
      title: 'Bank Payment',
      value: 1024,
      type: 'currency',
    },
    {
      id: 8,
      title: 'Paypal Payment',
      value: 30,
      type: 'currency',
    },
    {
      id: 9,
      title: 'Payoneer Payment',
      value: 10,
      type: 'currency',
    },
  ];

  // Dummy data
  public dummyData: any = [
    {
      id: '123',
      instructor: {
        id: 'b001',
        title: 'Faris Friansyah',
      },
      transactions: 23,
      payment_methode: 'Paypal',
      period: '2024-02-20T10:30:31.398Z',
      payout_type: 'Monthly',
      request_date: '2024-02-20T10:30:31.398Z',
      total_amount: 344,
    },
    {
      id: '123',
      instructor: {
        id: 'b001',
        title: 'Faris Friansyah',
      },
      transactions: 23,
      payment_methode: 'Paypal',
      period: '2024-02-20T10:30:31.398Z',
      payout_type: 'Monthly',
      request_date: '2024-02-20T10:30:31.398Z',
      total_amount: 344,
    },
    {
      id: '123',
      instructor: {
        id: 'b001',
        title: 'Faris Friansyah',
      },
      transactions: 23,
      payment_methode: 'Paypal',
      period: '2024-02-20T10:30:31.398Z',
      payout_type: 'Monthly',
      request_date: '2024-02-20T10:30:31.398Z',
      total_amount: 344,
    },
    {
      id: '122',
      instructor: {
        id: 'b001',
        title: 'Faris Friansyah',
      },
      transactions: 23,
      payment_methode: 'Paypal',
      period: '2024-02-20T10:30:31.398Z',
      payout_type: 'Monthly',
      request_date: '2024-02-20T10:30:31.398Z',
      total_amount: 344,
    },
    {
      id: '121',
      instructor: {
        id: 'b001',
        title: 'Faris Friansyah',
      },
      transactions: 23,
      payment_methode: 'Paypal',
      period: '2024-02-20T10:30:31.398Z',
      payout_type: 'Monthly',
      request_date: '2024-02-20T10:30:31.398Z',
      total_amount: 344,
    },
  ];
}
